import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import Immutable from 'immutable';
import { useScrollPercentage } from 'react-scroll-percentage';
import { trackEvent } from '../../actions/UI';

const Page = ({ children, className, loading, referenceLoading, ...props }) => {
  const hasLoadingItems = referenceLoading.get('itemsStarted') > 0;
  const isLoading = hasLoadingItems && (referenceLoading.get('itemsStarted') + 1) !== referenceLoading.get('itemsFinished');
  const entityType = useSelector((state) => state.getIn(['entity', 'entityType'], null));
  const entityId = useSelector((state) => state.getIn(['entity', 'entityId'], null));
  const title = useSelector((state) => state.getIn([entityType, entityId, 'title', 0, 'value'], Immutable.Map()));


  const dispatch = useDispatch();
  const headingOffset = 0.15;
  const [ref, percentage] = useScrollPercentage();
  const [reached70, setReached70] = useState(false);
  const [reached80, setReached80] = useState(false);
  const [reached90, setReached90] = useState(false);


  useEffect(() => {
    // Add the offset of the heading
    const offsetPercentage = percentage + headingOffset;
    if (reached70 === false && (offsetPercentage >= 0.70 && offsetPercentage < 0.80)) {
      dispatch(trackEvent('Scroll activity', 'Gescrolled tot 70%', title, null));
      setReached70(true);
    }
    if (reached80 === false && (offsetPercentage >= 0.80 && offsetPercentage < 0.90)) {
      dispatch(trackEvent('Scroll activity', 'Gescrolled tot 80%', title, null));
      setReached80(true);
    }
    if (reached90 === false && (offsetPercentage >= 0.90)) {
      dispatch(trackEvent('Scroll activity', 'Gescrolled tot 90%', title, null));
      setReached90(true);
    }
  }, [
    percentage,
    reached70,
    reached80,
    reached90,
    dispatch,
    title,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);


  const classes = classNames(className, 'Page');
  const contentWrapperClasses = classNames('page--inner-wrapper', {
    'has-loading-items': hasLoadingItems,
    loading: isLoading,
  });

  return (
    <div ref={ref} className={classes}>
      <div className={contentWrapperClasses}>
        {children}
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    referenceLoading: state.getIn(['ui', 'referenceLoading']),
  };
}

export default connect(mapStateToProps)(Page);
